import { Action } from 'redux'

import { OPEN_SPECIAL_SSR_MODAL } from '../../actions/modals/openSpecialSSRModal'
import { CLOSE_SPECIAL_SSR_MODAL } from '../../actions/modals/closeSpecialSSRModal'
import { OPEN_CSV_UPLOAD } from '../../actions/modals/openCSVUpload'
import { CLOSE_CSV_UPLOAD } from '../../actions/modals/closeCSVUpload'
import { OPEN_PASSENGERS_TO_BE_DELETED } from '../../actions/modals/openPassengersToBeDeletedConfirmation'
import { CLOSE_PASSENGERS_TO_BE_DELETED_CONFIRMATION } from '../../actions/modals/closePassengersToBeDeletedConfirmation'

export interface ModalsState {
  isSpecialSSRModalOpen: boolean
  isCSVUploadModalOpen: boolean
  isPassengersToBeDeletedModalOpen: boolean
}

export const initialState: ModalsState = {
  isSpecialSSRModalOpen: false,
  isCSVUploadModalOpen: false,
  isPassengersToBeDeletedModalOpen: false,
}

export default (
  state = initialState,
  action: Action = {
    type: '',
  }
) => {
  switch (action.type) {
    case OPEN_SPECIAL_SSR_MODAL:
      return {
        ...state,
        isSpecialSSRModalOpen: true,
      }

    case CLOSE_SPECIAL_SSR_MODAL:
      return {
        ...state,
        isSpecialSSRModalOpen: false,
      }

    case OPEN_CSV_UPLOAD:
      return {
        ...state,
        isCSVUploadModalOpen: true,
      }

    case CLOSE_CSV_UPLOAD:
      return {
        ...state,
        isCSVUploadModalOpen: false,
      }

    case OPEN_PASSENGERS_TO_BE_DELETED:
      return {
        ...state,
        isPassengersToBeDeletedModalOpen: true,
      }

    case CLOSE_PASSENGERS_TO_BE_DELETED_CONFIRMATION:
      return {
        ...state,
        isPassengersToBeDeletedModalOpen: false,
      }

    default:
      return state
  }
}
